<template>
    <div class="preview__large">
        <div class="preview__large-header">
            <span>visitante</span>
        </div>
        <div class="preview__large-body">
            <div class="preview__large-qr">
                <img src="../../../assets/qr/qr_preview-small.png" alt="qr-preview">
            </div>  
            <div class="preview__large-content">
                    <h1 :class="{'py-0': $vuetify.breakpoint.xs, 'py-1': $vuetify.breakpoint.xl}">
                      {{ visitPerson.name }}
                    </h1>

                     <v-checkbox  @change="checkDataLarge()"  color="red" :class="{'py-0': $vuetify.breakpoint.xs, 'py-1': $vuetify.breakpoint.xl}" v-model="checkHostLarge" hide-details>
                        <template v-slot:label>
                          <div class="visit">
                            <h4>A QUIÉN VISITA: <span>{{ visitPreview.hostNames }}</span></h4>
                          </div>
                        </template>
                      </v-checkbox>


                       <div class="checkbox__date" :class="{'py-0': $vuetify.breakpoint.xs, 'py-1': $vuetify.breakpoint.xl}">
                      <v-checkbox @change="checkDataLarge()"  color="red" v-model="checkDateLarge" hide-details>
                        <template v-slot:label>
                          <div class="visit__date">
                             <span>Fecha {{ visitPreview.date | formatDateA }}</span>
                          </div>
                        </template>
                      </v-checkbox>

                      <v-checkbox @change="checkDataLarge()" color="red" v-model="checkTimeLarge" hide-details>
                        <template v-slot:label>
                          <div class="visit__date">
                             <span>Hora {{ visitPreview.date | formatDateB }}</span>
                        
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
            </div>

        </div>
                    <h2 :class="{'py-0': $vuetify.breakpoint.xs, 'py-2': $vuetify.breakpoint.xl}">{{ visitPreview.branchName }}</h2>

    </div>
</template>

<script>
export default {
    name: "VisitPreviewTagLarge",
    props: ["visitPreview", "visitPerson"],
    data() {
        return {
           checkHostLarge: true,
           checkDateLarge: true,
           checkTimeLarge: true

        }
    },
    methods: {
      checkDataLarge(){
        this.$emit('checkdata-large', this.checkHostLarge, this.checkDateLarge, this.checkTimeLarge)
      }
    }
}
</script>

<style lang="css" scoped>
.preview__large {
    width: 75%;
    margin: auto;
    border: 2px solid #000;
}
.preview__large-header{
    width: 100%;
    height: 40px;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.preview__large-header span{
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
}
.preview__large-body{
   display: flex;
    align-items: center;
    justify-content: center;

}
.preview__large-qr{
    width: 40%;
}
.preview__large-qr img{
    width: 100%;
    padding: 10px;
}
.preview__large-content{
    width: 60%;
  
}
.preview__large-content h1{
    text-transform: uppercase;
}
.visit h4{
font-weight: 700;
color: #000;
}
.visit span{
    text-transform: uppercase;
font-weight: normal;
color: #000;
}
.checkbox__date {
  display: flex;
  align-items: center;
  align-content: stretch;
  justify-content: space-evenly;
}
.visit__date{
    font-weight: normal;
    color: #000;
}
@media (max-width: 575px) {
  .preview__large {
    width: 100%;
}
.preview__large-content h1{
    font-size: 15px;
}
.preview__large h2{
    font-size: 15px;
}
.visit h4 {
 font-size: 13px;
}
.visit__date {
  font-size: 13px;
}
}
</style>